import React, {useState} from 'react';
import {useMountEffect} from 'primereact/hooks';

const Calculator = ({moveToNextView, moveToPreviousView, userPolicyInput, setuserPolicyInput}) => {
    const [products, setProducts] = useState([]);
    const [selectedProduct, setSelectedProduct] = useState(null);

    useMountEffect(() => {
        setProducts(userPolicyInput.selectedSubGroupPlan.planProducts || []);
        if (userPolicyInput.selectedProduct) {
            setSelectedProduct(userPolicyInput.selectedProduct);
        }
    });

    const handleSelect = (product) => {
        setSelectedProduct(product);
        setuserPolicyInput({
            ...userPolicyInput,
            selectedProduct: product,
            selectedProductId: product.ProductID,
            selectedProductName: product.ProductName1
        });
    };

    return (
        <div className="w-full">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {products.length === 0 && (
                    <div className="col-span-full text-center p-6 text-base-content/50">No products available for this
                        plan.</div>
                )}

                {products.map((product) => {
                    const isSelected = selectedProduct && selectedProduct.ProductName1 === product.ProductName1;

                    let benefitsList = [];
                    if (product.BenefitsText) {
                        benefitsList = product.BenefitsText.split(',').map(b => b.trim()).filter(b => b.length > 0);
                    }

                    return (
                        <div
                            key={product.ProductName1}
                            className={`card bg-base-100 shadow-sm transition-all duration-300 flex flex-col h-full rounded-2xl 
                            ${isSelected ? 'border-2 border-primary ring-4 ring-primary/5 scale-[1.02] shadow-md' : 'border border-base-300 hover:border-primary/40 hover:shadow-md'}`}
                        >
                            <div className="card-body p-6 flex flex-col flex-grow">
                                <div className="flex justify-between items-start mb-4">
                                    <h2 className="text-xl font-bold text-base-content uppercase tracking-wide leading-tight line-clamp-2">
                                        {product.ProductName1}
                                    </h2>
                                </div>

                                <ul className="mt-2 mb-6 flex flex-col gap-3 text-sm flex-grow">
                                    {benefitsList.length > 0 ? (
                                        benefitsList.map((benefit, i) => (
                                            <li key={benefit} className="flex items-start">
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    className="w-5 h-5 mr-3 flex-shrink-0 text-success"
                                                    fill="none"
                                                    viewBox="0 0 24 24"
                                                    stroke="currentColor">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5"
                                                          d="M5 13l4 4L19 7"/>
                                                </svg>
                                                <span className="text-base-content/80 font-medium leading-tight capitalize">
                                                    {benefit.toString().toLowerCase()}
                                                </span>
                                            </li>
                                        ))
                                    ) : (
                                        <li className="text-base-content/50 italic">Standard benefits apply.</li>
                                    )}
                                </ul>

                                <div className="mt-auto pt-4 border-t border-base-200">
                                    <button
                                        onClick={() => handleSelect(product)}
                                        className={`btn btn-block rounded-full shadow-sm ${isSelected ? 'btn-primary text-white' : 'btn-outline btn-primary'}`}
                                    >
                                        {isSelected ? (
                                            <>
                                                <i className="pi pi-check mr-1"></i> Selected
                                            </>
                                        ) : 'Select Plan'}
                                    </button>
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default Calculator;
